/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MilestoneResponse } from './MilestoneResponse';
import {
    MilestoneResponseFromJSON,
    MilestoneResponseFromJSONTyped,
    MilestoneResponseToJSON,
    MilestoneResponseToJSONTyped,
} from './MilestoneResponse';
import type { QuestReset } from './QuestReset';
import {
    QuestResetFromJSON,
    QuestResetFromJSONTyped,
    QuestResetToJSON,
    QuestResetToJSONTyped,
} from './QuestReset';
import type { RewardConfigResponse } from './RewardConfigResponse';
import {
    RewardConfigResponseFromJSON,
    RewardConfigResponseFromJSONTyped,
    RewardConfigResponseToJSON,
    RewardConfigResponseToJSONTyped,
} from './RewardConfigResponse';
import type { OWUserStat } from './OWUserStat';
import {
    OWUserStatFromJSON,
    OWUserStatFromJSONTyped,
    OWUserStatToJSON,
    OWUserStatToJSONTyped,
} from './OWUserStat';
import type { OWRewardMaxType } from './OWRewardMaxType';
import {
    OWRewardMaxTypeFromJSON,
    OWRewardMaxTypeFromJSONTyped,
    OWRewardMaxTypeToJSON,
    OWRewardMaxTypeToJSONTyped,
} from './OWRewardMaxType';
import type { OWLogCategory } from './OWLogCategory';
import {
    OWLogCategoryFromJSON,
    OWLogCategoryFromJSONTyped,
    OWLogCategoryToJSON,
    OWLogCategoryToJSONTyped,
} from './OWLogCategory';
import type { OWRewardMode } from './OWRewardMode';
import {
    OWRewardModeFromJSON,
    OWRewardModeFromJSONTyped,
    OWRewardModeToJSON,
    OWRewardModeToJSONTyped,
} from './OWRewardMode';

/**
 * Collection contains the rewards that can be claimed.
 * @export
 * @interface OWReward
 */
export interface OWReward {
    /**
     * 
     * @type {string}
     * @memberof OWReward
     */
    game?: string;
    /**
     * The title of the reward.
     * @type {string}
     * @memberof OWReward
     */
    name: string;
    /**
     * The description of the reward.
     * @type {string}
     * @memberof OWReward
     */
    description?: string;
    /**
     * If the quest is active (shows on FE and processes event logs in BE) or not.
     * @type {boolean}
     * @memberof OWReward
     */
    isActive: boolean;
    /**
     * If the quest complete notification should be shown.
     * @type {boolean}
     * @memberof OWReward
     */
    showQuestCompleteNotification?: boolean;
    /**
     * The message to show in the quest complete notification.
     * @type {string}
     * @memberof OWReward
     */
    questCompleteNotificationMessage?: string;
    /**
     * The maximum amount of XP that can be claimed for the 1hr time quest.
     * @type {number}
     * @memberof OWReward
     */
    rewardMax?: number;
    /**
     * 
     * @type {OWRewardMaxType}
     * @memberof OWReward
     */
    rewardMaxType?: OWRewardMaxType;
    /**
     * 
     * @type {QuestReset}
     * @memberof OWReward
     */
    questReset: QuestReset;
    /**
     * 
     * @type {OWLogCategory}
     * @memberof OWReward
     */
    rewardCategory: OWLogCategory;
    /**
     * 
     * @type {string}
     * @memberof OWReward
     */
    eventType: string;
    /**
     * The target amount of progress to reach to claim the reward.
     * @type {number}
     * @memberof OWReward
     */
    target: number;
    /**
     * 
     * @type {Array<MilestoneResponse>}
     * @memberof OWReward
     */
    milestones?: Array<MilestoneResponse>;
    /**
     * 
     * @type {Array<RewardConfigResponse>}
     * @memberof OWReward
     */
    rewardConfigs?: Array<RewardConfigResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof OWReward
     */
    isSponsored?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OWReward
     */
    sponsorName?: string;
    /**
     * 
     * @type {string}
     * @memberof OWReward
     */
    logo?: string;
    /**
     * 
     * @type {string}
     * @memberof OWReward
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof OWReward
     */
    externalUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof OWReward
     */
    rewardImage?: string;
    /**
     * 
     * @type {number}
     * @memberof OWReward
     */
    startAt?: number;
    /**
     * 
     * @type {number}
     * @memberof OWReward
     */
    endAt?: number;
    /**
     * Ref to the challenge of this quest (only for challenge quests).
     * @type {string}
     * @memberof OWReward
     */
    challenge?: string;
    /**
     * 
     * @type {OWUserStat}
     * @memberof OWReward
     */
    userStat?: OWUserStat;
    /**
     * If the TIME quest is available for all supported games that are not in our database (OWGames).
     * @type {boolean}
     * @memberof OWReward
     */
    onAllSupportedGames?: boolean;
    /**
     * 
     * @type {OWRewardMode}
     * @memberof OWReward
     */
    mode?: OWRewardMode;
    /**
     * 
     * @type {string}
     * @memberof OWReward
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof OWReward
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof OWReward
     */
    updatedAt: number;
}



/**
 * Check if a given object implements the OWReward interface.
 */
export function instanceOfOWReward(value: object): value is OWReward {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('questReset' in value) || value['questReset'] === undefined) return false;
    if (!('rewardCategory' in value) || value['rewardCategory'] === undefined) return false;
    if (!('eventType' in value) || value['eventType'] === undefined) return false;
    if (!('target' in value) || value['target'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function OWRewardFromJSON(json: any): OWReward {
    return OWRewardFromJSONTyped(json, false);
}

export function OWRewardFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWReward {
    if (json == null) {
        return json;
    }
    return {
        
        'game': json['game'] == null ? undefined : json['game'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'isActive': json['isActive'],
        'showQuestCompleteNotification': json['showQuestCompleteNotification'] == null ? undefined : json['showQuestCompleteNotification'],
        'questCompleteNotificationMessage': json['questCompleteNotificationMessage'] == null ? undefined : json['questCompleteNotificationMessage'],
        'rewardMax': json['rewardMax'] == null ? undefined : json['rewardMax'],
        'rewardMaxType': json['rewardMaxType'] == null ? undefined : OWRewardMaxTypeFromJSON(json['rewardMaxType']),
        'questReset': QuestResetFromJSON(json['questReset']),
        'rewardCategory': OWLogCategoryFromJSON(json['rewardCategory']),
        'eventType': json['eventType'],
        'target': json['target'],
        'milestones': json['milestones'] == null ? undefined : ((json['milestones'] as Array<any>).map(MilestoneResponseFromJSON)),
        'rewardConfigs': json['rewardConfigs'] == null ? undefined : ((json['rewardConfigs'] as Array<any>).map(RewardConfigResponseFromJSON)),
        'isSponsored': json['isSponsored'] == null ? undefined : json['isSponsored'],
        'sponsorName': json['sponsorName'] == null ? undefined : json['sponsorName'],
        'logo': json['logo'] == null ? undefined : json['logo'],
        'color': json['color'] == null ? undefined : json['color'],
        'externalUrl': json['externalUrl'] == null ? undefined : json['externalUrl'],
        'rewardImage': json['rewardImage'] == null ? undefined : json['rewardImage'],
        'startAt': json['startAt'] == null ? undefined : json['startAt'],
        'endAt': json['endAt'] == null ? undefined : json['endAt'],
        'challenge': json['challenge'] == null ? undefined : json['challenge'],
        'userStat': json['userStat'] == null ? undefined : OWUserStatFromJSON(json['userStat']),
        'onAllSupportedGames': json['onAllSupportedGames'] == null ? undefined : json['onAllSupportedGames'],
        'mode': json['mode'] == null ? undefined : OWRewardModeFromJSON(json['mode']),
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}

export function OWRewardToJSON(json: any): OWReward {
    return OWRewardToJSONTyped(json, false);
}

export function OWRewardToJSONTyped(value?: OWReward | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'game': value['game'],
        'name': value['name'],
        'description': value['description'],
        'isActive': value['isActive'],
        'showQuestCompleteNotification': value['showQuestCompleteNotification'],
        'questCompleteNotificationMessage': value['questCompleteNotificationMessage'],
        'rewardMax': value['rewardMax'],
        'rewardMaxType': OWRewardMaxTypeToJSON(value['rewardMaxType']),
        'questReset': QuestResetToJSON(value['questReset']),
        'rewardCategory': OWLogCategoryToJSON(value['rewardCategory']),
        'eventType': value['eventType'],
        'target': value['target'],
        'milestones': value['milestones'] == null ? undefined : ((value['milestones'] as Array<any>).map(MilestoneResponseToJSON)),
        'rewardConfigs': value['rewardConfigs'] == null ? undefined : ((value['rewardConfigs'] as Array<any>).map(RewardConfigResponseToJSON)),
        'isSponsored': value['isSponsored'],
        'sponsorName': value['sponsorName'],
        'logo': value['logo'],
        'color': value['color'],
        'externalUrl': value['externalUrl'],
        'rewardImage': value['rewardImage'],
        'startAt': value['startAt'],
        'endAt': value['endAt'],
        'challenge': value['challenge'],
        'userStat': OWUserStatToJSON(value['userStat']),
        'onAllSupportedGames': value['onAllSupportedGames'],
        'mode': OWRewardModeToJSON(value['mode']),
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

